<template>
  <div id="classDetailsDiv">
    <div class="classDetailsDiv_content">
      <div class="head_title class_head_title">
        <div class="head_title_font class_head_title_font">
          <span>外聘教师评估统计</span>

        </div>
        <div class="searcharea">
          <label>时间筛选:</label>
          <input type="text" class="form-control" name="chooseStartDate" id="chooseStartDate" v-model="queryDate.startDate" style="width: 120px;display: inline-block" readonly>
          &nbsp;&nbsp;—&nbsp;&nbsp;
          <input type="text" class="form-control" name="chooseEndDate" id="chooseEndDate" v-model="queryDate.endDate" style="width: 120px;display: inline-block" readonly>
          <button class="btn btn-default btn_option" style="height: 28px;line-height: 10px;margin-bottom: 3px" @click="initEvaluationListData()">查询</button>
          <button type="button" class="btn btn-default btn_option"
                  style="height: 28px;line-height: 10px;margin-bottom: 3px"
                  @click="exportEvaluationInfo()">导出</button>

        </div>
      </div>
      <div class="body_content class_body_content">



        <div class="class_body_content_self">
          <table class="table table-striped table-bordered tbl_evaluation">
            <thead>
            <tr>
              <th class="tablexuhao" width="5%">序号</th>
              <th width="30%">主讲教师</th>
              <th width="30%">课程评估数</th>
              <th width="25%">总和平均分</th>
              <th width="5%">详情</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(clazzEvaluation,index) in clazzEvaluationList" :key="index">
              <td width="5%">{{index+1}}</td>
              <td width="30%">{{clazzEvaluation.teacherName}}</td>
              <td width="30%">{{clazzEvaluation.contentNum}}</td>
              <td width="25%">{{clazzEvaluation.score}}</td>
              <td width="5%">
                <div class="details_pic" data-toggle="modal" data-target="#myModal" @click="getDetails(clazzEvaluation.teacherId,queryDate.startDate,queryDate.endDate)"></div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- 模态框（Modal） -->
    <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h4 class="modal-title" id="myModalLabel">评估详情</h4>
          </div>
          <div class="modal-body">
            <div class="evaluation evaluation_details">
              <table class="table table-striped table-bordered other_tab">
                <thead>
                <tr>
                  <th width="">培训时间</th>
                  <th width="">班次</th>
                  <th width="">教学内容</th>
                  <th width="">已评估人数/总评估人数</th>
                  <th width="">平均分</th>
                  <th width="">其他意见个数</th>
                  <th width="10%">详情</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(studentEvaluate,index) in evaluationList" :key="index">
                  <td>{{studentEvaluate.startDate}} {{studentEvaluate.time}}</td>
                  <td>{{studentEvaluate.clazzName}}</td>
                  <td>{{studentEvaluate.name}}</td>
                  <td>{{studentEvaluate.contentNum}}/{{studentEvaluate.numStudent}}</td>
                  <td>{{studentEvaluate.score}}</td>
                  <td>
                    {{studentEvaluate.contentNums}}
                  </td>
                  <td>
                    <div class="details_pic" data-toggle="modal" data-target="#myEvModal" @click="getEvDetails(studentEvaluate)"></div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="showme_details" class="float_deteils_div" :class="{isShowDivClass: isShowDiv}">
      <div class="scroeDetail classEvaluationScore">
        <p v-for="(q, i) in currentQuestionnaire.filter(i=>i.type!='1')"><b>{{q.title}}:</b>{{studentScoreDetailsrespList['item'+(i+1)]}}</p>
      </div>
    </div>
    <!-- 评估详情模态框（Modal） -->
    <div class="modal fade" id="myEvModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h4 class="modal-title" id="myModalLabel">
              <span>《{{details_lesson_name}}》干部培训课程质量评估</span>
            </h4>
          </div>
          <div class="modal-body">
            <div class="evaluation teacher_introduce">
              <b>主讲：</b>{{details_teacher_name}}
              <b>日期：</b>{{details_startDate_name}}
              <b>评估人数：</b>{{details_numStudent_name}}
              <!--<b>type:</b>{{details_type}}-->
            </div>
            <div class="evaluation evaluation_all">
              <table class="table table-striped table-bordered">
                <thead>
                <tr v-if="currentQuestionnaire.filter(i=>i.type=='1').length>0">
                  <th v-for="q in currentQuestionnaire" v-if="q.type == '1'" :colspan="q.colspan">{{q.title}}（{{q.maxValue}}）</th>
                  <th></th>
                </tr>
                <tr>
                  <th v-for="q in currentQuestionnaire" v-if="q.type != '1'">{{q.title}}（{{q.maxValue}}）</th>
                  <th>总分（{{ totalScore }}）</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(clazzEvaluation,index) in studentEvaluationAvgList" :key="index">
                  <td v-for="(q, i) in currentQuestionnaire.filter(i=>i.type!='1')" v-if="q.type != '1'">{{clazzEvaluation['item'+(i+1)]}}</td>
                  <td>{{clazzEvaluation.score}}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="evaluation evaluation_details">
              <table class="table table-striped table-bordered other_tab">
                <thead>
                <tr>
                  <th width="20%">评估学员</th>
                  <th width="10%">总给分（100）</th>
                  <th width="60%">其他建议</th>
                  <th width="10%">详情</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(studentEvalua,index) in studentEvaluationList" :key="index">
                  <td width="20%">**</td>
                  <td width="10%">{{studentEvalua.score}}</td>
                  <td width="60%">{{studentEvalua.content}}</td>
                  <td width="10%">
                    <div class="details_pic" v-on:mouseover="student_id=studentEvalua.id;getStudentScoreDetails($event)" v-on:mouseout="isShowDiv=false"></div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {schoolAxios} from '../main';
import {getContentSize} from './mainView';

export default {
  name: "teachingEvaluationOutside",
  data(){
    return{
      clazzId: this.$store.state.clazzId,
      token: this.$store.state.access_token,
      serviceBase:this.$store.state.serviceBase,

      clazzEvaluationList: [],
      evaluationList: [],
      evaluationInfo: {
        id:'',
        teacherId: '',
      },

      queryDate:{
        startDate:'',
        endDate:'',
      },

      content: '',
      isShowDiv: false,

      checkbox: {
        checkIds: [],
      },

      studentEvaluationAvgList: [],
      studentEvaluationList: [],
      details_lesson_id: '',
      details_lesson_name: '',
      details_teacher_name: '',
      details_startDate_name: '',
      details_numStudent_name: '',
      currentQuestionnaireId:"",
      currentQuestionnaire:[],
      studentScoreDetailsrespList: {},
      student_id: '',

      hrefExport:this.$store.state.serviceBase+"resources/",

      //今日日期
      timeDate: '',
      totalScore:0
    }
  },
  mounted: function () {
    let this_ = this;
    this.$nextTick(function () {
      getContentSize();
      //刷新页面首次加载
      this_.initEvaluationListData();
      this_.dateDefault();
    });
  },
  methods: {
    initEvaluationListData() {
      let this_ = this;
      schoolAxios({
        method: 'get',
        url: 'evaluate/findStatisticalEvaluateBy',
        params: {
          "beginDate":this_.queryDate.startDate,
          "endDate":this_.queryDate.endDate,
          "type":'1'
        }
      }).then(function (resp) {
        console.log(resp)
        this_.clazzEvaluationList = resp.data.list;
      });
    },
    /**
     * 查询详情
     */
    getDetails(teacherId,beginDate,endDate){
      let this_ = this;
      schoolAxios({
        method: 'get',
        url: 'evaluate/findListEvaluateByTeacher',
        params: {
          teacherId: teacherId,
          beginDate:beginDate,
          endDate:endDate
        }
      }).then(function (studentresp) {
        if(studentresp.data.success){
          this_.evaluationList = studentresp.data.list;
        }
      });
      /* $("#myModal").modal("show");*/
    },
    getStudentContents(content){
      // console.info(content);
      $("#showme_details").css("left", event.screenX-300).css("top", event.screenY-150);
      let this_=this;
      this_.content = content;
      //$("#myModal").modal("show");
    },

    checkedOne (teacherId) {
      let this_ = this;
      let idIndex = this_.checkbox.checkIds.indexOf(teacherId);
      if (idIndex >= 0) {//如果已经包含就去除
        this_.checkbox.checkIds.splice(idIndex, 1);
      } else {//如果没有包含就添加
        this_.checkbox.checkIds.push(teacherId);
      }
    },
    /*全选*/
    checkAll: function (e) {
      let this_ = this;
      let checked = e.target.checked;
      if(checked){
        this_.checkbox.checkIds=[];
        let clazzEvaluationList = this_.clazzEvaluationList;
        for(let i=0;i<clazzEvaluationList.length;i++){
          let idIndex = this_.checkbox.checkIds.indexOf(clazzEvaluationList[i].teacherId);
          if (idIndex < 0) {//如果没有包含就添加
            this_.checkbox.checkIds.push(clazzEvaluationList[i].teacherId);
          }
        }
      }else{
        this_.checkbox.checkIds=[];
      }
      let element = document.querySelectorAll("input[name=list_item]");
      element.forEach((item) => {
        item.checked = checked;
      });
    },
    /**
     * 导出
     */
    exportEvaluationInfo(){
      let this_=this;
      let teacherIds =this_.checkbox.checkIds.toString();
      schoolAxios({
        method: 'get',
        url:'evaluate/evaluateExcelExport',
        params: {
          "beginDate":this_.queryDate.startDate,
          "endDate":this_.queryDate.endDate,
          "access_token":this_.token,
          "type":'1'
        }
      }).then(function (response) {
        if(response.data.success){
          location.href=this_.hrefExport+response.data.data;
        }else {
          (response.data.message||"导出失败").showMessage();
        }
      });
      /*if(teacherIds){
        location.href=this_.serviceBase+"evaluate/evaluateExcelExport?access_token="+this_.token+"&teacherIds="+this_.checkbox.checkIds.toString();
      }else {
        "请勾选导出数据".showMessage();
      }*/
    },

    initEvaluationTemplate(id, callback){
      if(this.currentQuestionnaireId == id){
        if(callback) callback.call(this);
        return;//同一评估ID跳过
      }
      this.currentQuestionnaireId = id;
      let this_ = this;
      schoolAxios({
        method: 'get',
        url: 'questionnaire/getItemlistById',
        params: {
          id: id
        }
      }).then(function (resp) {
        if(resp.data.success){
          this_.currentQuestionnaire = resp.data.list;

          let colspan = 0
          let cItem;
          this_.totalScore = 0;
          this_.currentQuestionnaire.forEach(item => {
            if(item.type == '1'){
              if(cItem && colspan) {
                cItem.colspan = colspan;
              }
              colspan = 0;
              cItem = item;
            }else{
              colspan ++;
              this_.totalScore += Number(item.maxValue)
            }
          })
          if(cItem && colspan){
            cItem.colspan = colspan;
          }

          if(callback) callback.call(this);
        }
      });
    },
    /**
     * 查询详情
     */
    getEvDetails(clazzEvaluation){
      this.details_lesson_id=clazzEvaluation.id;
      this.details_lesson_name=clazzEvaluation.name;
      this.details_teacher_name=clazzEvaluation.teacherName;
      this.details_startDate_name=clazzEvaluation.startDate;
      this.details_numStudent_name=clazzEvaluation.contentNum;
      let this_ = this;
      this_.details_type=clazzEvaluation.type;
      this.initEvaluationTemplate(clazzEvaluation.questionnaireId, function (){

        schoolAxios({
          method: 'get',
          url: 'evaluate/getLessonEvaluateMsg',
          params: {
            teacherId: clazzEvaluation.teacherId,
            lessonId: clazzEvaluation.id
          }
        }).then(function (studentresp) {
          if(studentresp.data.success){
            this_.studentEvaluationAvgList = studentresp.data.list;
          }
        });
        schoolAxios({
          method: 'get',
          url: 'evaluate/StudentEvaluateMsg',
          params: {
            teacherId: clazzEvaluation.teacherId,
            lessonId: clazzEvaluation.id
          }
        }).then(function (studentresp) {
          if(studentresp.data.success){
            this_.studentEvaluationList = studentresp.data.list;
          }
        });
      });
      // $("#myEvModal").modal("show");
    },

    getStudentScoreDetails(event){
      if(this.isShowDiv===true) return;
      this.isShowDiv=true;
      $("#showme_details").css("left", event.pageX-100).css("top", event.pageY-150);
      let this_ = this;
      schoolAxios({
        method: 'get',
        url: 'evaluate/load/'+this_.student_id,
        params: {
        }
      }).then(function (studentScoreDetailsresp) {
        /*console.log(studentScoreDetailsresp)*/
        if(studentScoreDetailsresp.data.success){
          this_.studentScoreDetailsrespList = studentScoreDetailsresp.data.data;
        }
      });
    },


    /**
     * 初始化日期选择框
     */
    dateDefault(){
      let this_ = this;
      let date, nowDate;
      date = new Date();
      nowDate = date.getFullYear() + "-";
      nowDate += (date.getMonth() + 1) + "-";
      nowDate += date.getDate() + " ";
      this_.timeDate = nowDate;
      $('#chooseStartDate').datetimepicker({
        minView: "month",//选择日期后，不会再跳转去选择时分秒
        language: 'zh-CN',
        format: 'yyyy-mm-dd',
        //startDate: this_.timeDate,
        weekStart: 0,
        todayBtn: true,
        clearBtn: true,
        autoclose: true,//选择一个日期后是否立即关闭此选择框
        todayHighlight: true,//高亮当前日期
        startView: 2,// 日期时间选择器打开之后首先显示的视图，默认值为：2，0:hour,1:day,2:mouth,3:year,4:decade
        forceParse: 0,
        showMeridian: 1,
      }).on('hide', function (ev) {
        let value = $("#chooseStartDate").val();
        this_.queryDate.startDate = value;
        ev.preventDefault();
        ev.stopPropagation();
      });
      $('#chooseEndDate').datetimepicker({
        minView: "month",
        language: 'zh-CN',
        format: 'yyyy-mm-dd',
        //startDate: this_.timeDate,
        weekStart: 0,
        todayBtn: true,
        clearBtn: true,
        autoclose: true,
        todayHighlight: true,
        startView: 2,
        forceParse: 0,
        showMeridian: 1,
      }).on('hide', function (ev) {
        let value = $("#chooseEndDate").val();
        this_.queryDate.endDate = value;
        ev.preventDefault();
        ev.stopPropagation();
      });
    },
  }
}
</script>

<style scoped>
@import '../assets/css/plugins.css';
@import "../assets/css/publicStyle.css";
.teachingEvaluationAll_body_content {
  margin: 5px 0 0 0;
}
.table {
  color: #FFFFFF;
}
.table th {
  color: black;
  background-color: #cccccc;
}
.table tr{
  color: black;
  background-color: #FFFFFF;
}
.table,.table th {
  text-align: center;
}
.class_body_content_self {
  width: 100%;
  height: auto;
  margin-top: 10px;
}
.details_pic {
  margin: auto;
  width: 29px;
  height: 22px;
  /*background-image: url("../img/right/teachingEvaluation/details_disabled.png");*/
  background-image: url("../assets/img/right/clazz/details_mouseOver.png");
  background-size: 100% 100%;
}
/*.details_pic:hover{
  background-image: url("../img/right/teachingEvaluation/details_mouseOver.png");
}*/

.modal-dialog {
  width: 60%;
  height: 60%;
}
.modal-content {
  width: 100%;
  /* height: 100%;*/
  overflow: auto;
}
.modal-title {
  text-align: center;
}
.modal-header {
  height: 8%;
}
.modal-body {
  /*height: 92%;*/
}

.teacher_introduce {
  width: 100%;
  height: 6%;
}
.evaluation_all {
  width: 100%;
  height: 16%;
}
.evaluation_details {
  width: 100%;
  height: 78%;
  overflow: auto;
}
.evaluation_details table {
  width: 100%;
  max-height: 96%;
  overflow: auto;
}

.float_deteils_div {
  padding: 20px;
  position: fixed;
  top: 0;
  left: 30%;
  transform: translate(-50%, 0);
  width: 180px;
  overflow: auto;
  z-index: 2000;
  background-color: white;
  display: none;
  border: 1px solid black;
}
.isShowDivClass {
  display: block;
}
.scroeDetail{
  /*text-align: center;*/
}
/*教学评估模态框表头固定*/

.searcharea{
  position: absolute;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/teachingEvaluationOutside.vue